<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Replace: {{ selectedSensor.serialNumber }}
      </div>
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <!-- <div v-if="!showDropDown">
        There aren't any sensors available to replace this one with.
      </div>
      <div v-if="showDropDown" style="margin-top:40px;">
        Choose a Sensor
      </div> v-if="showDropDown"  -->
      <div class="margin-top-4">
        <SACDropdown
          placeholder="Select Serial"
          :options="serialOptions"
          field="selectedSerial"
          :value="selectedSerial"
          :change="(field, value) => selectSerialToReplaceWith(value)"
        />
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="replaceSelectedSensor"
      >
        Replace
      </button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';

export default {
  name: 'ReplaceSensor',
  components: {
    SACDropdown,
  },
  mixins: [customerDetailMixin],
  data() {
    return {
      serialOptions: [],
      showDropDown: [],
    };
  },
  mounted() {
    const sensorsCopy = _.cloneDeep(this.sensors);
    const selectedSensorCopy = _.cloneDeep(this.selectedSensor);
    const correctSensorOptions = [];
    let showDropDown = false;
    sensorsCopy.forEach((s) => {
      if (selectedSensorCopy.sensorType.toLowerCase().includes('water')) {
        if (s.sensorType.toLowerCase().includes('water')) {
          if (s.serialNumber !== selectedSensorCopy.serialNumber
            && s.uid === selectedSensorCopy.uid) {
            const option = {
              label: s.serialNumber,
              value: s.serialNumber,
            };
            correctSensorOptions.push(option);
            showDropDown = true;
          }
        }
      } else if (selectedSensorCopy.sensorType.toLowerCase().includes('temp')
        && !selectedSensorCopy.sensorType.toLowerCase().includes('pressure')) {
        if (s.sensorType.toLowerCase().includes('temp')
          && !s.sensorType.toLowerCase().includes('pressure')) {
          if (s.serialNumber !== selectedSensorCopy.serialNumber
            && s.uid === selectedSensorCopy.uid) {
            const option = {
              label: s.serialNumber,
              value: s.serialNumber,
            };
            correctSensorOptions.push(option);
            showDropDown = true;
          }
        }
      } else if (selectedSensorCopy.sensorType.toLowerCase().includes('pressure')) {
        if (s.sensorType.toLowerCase().includes('pressure')) {
          if (s.serialNumber !== selectedSensorCopy.serialNumber
            && s.uid === selectedSensorCopy.uid) {
            const option = {
              label: s.serialNumber,
              value: s.serialNumber,
            };
            correctSensorOptions.push(option);
            showDropDown = true;
          }
        }
      }
    });
    if (!showDropDown) {
      correctSensorOptions.push({ label: '', value: '' });
    }
    this.serialOptions = correctSensorOptions;
    this.showDropDown = showDropDown;
  },
  methods: {
    selectSerialToReplaceWith(v) {
      this.$store.dispatch('changeCustomerDetailValue', {
        field: 'selectedSerial',
        value: v,
      });
    },
    replaceSelectedSensor() {
      const payload = {
        oldSerial: this.selectedSensor.serialNumber,
        newSerial: this.selectedSerial,
      };
      this.$store.dispatch('replaceSensor', payload);
      this.toggleActionModal(false);
    },
  },
};
</script>
